import React from 'react'
import { useModalsDispatch } from '@contexts'
import { EditorContext } from '../EditorContext'
import { SelectedElementTooltipItem } from './SelectedElementTooltipItem'

export const FormulaGraphTooltipItem = () => {
  const { canvas } = React.useContext(EditorContext)
  const { open } = useModalsDispatch()

  const onClick = () => {
    const activeObject = canvas.current.getActiveObject()
    canvas.current.discardActiveObject()

    open({
      name: 'formula-graph-modal',
      data: {
        id: activeObject.id,
        type: activeObject.type,
        latex: activeObject.data
      }
    })
  }

  return (
    <SelectedElementTooltipItem
      icon='sum'
      tooltip='Formula Graph tool'
      onClick={onClick}
    />
  )
}
